import "./TopBox.scss";
import baking from "../../assets/images/baking.jpg";

const TopBox = () => {
  return (
    <div className="top-box">
      <img src={baking} alt="home" className="top-box__img" />
      <div className="top-box__container">
        <h1 className="top-box__title">When?</h1>
        <p className="top-box__text">
          Low Key Bakerr started when I wanted something to do with my younger
          counsins. I started to teach myself after work with youtube tutorials
          on the down low just in case it didn't work out!
        </p>
      </div>
    </div>
  );
};

export default TopBox;
